<template>
    <v-alert transition="fade" :dismissible="false" v-model="show" :color="status">
        <slot></slot>
    </v-alert>
</template>

<script>

    export default {
        name: "BaseFormMessage",
        data: function(){
            return {
                show: true

            }
        },
        props: {
            status: String
        },


    }

</script>


<style scoped lang="scss">

</style>